import { tabsAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import colorScheme, { Color } from 'presentation/theme/colorScheme';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(tabsAnatomy.keys);

// define the base component styles
const baseStyle = definePartsStyle({
  tab: {
    _selected: {
      py: '16px',
      borderBottomColor: 'transparent !important',
      boxShadow: `inset 0px -6px 0px 0px ${colorScheme[Color.Primary500]}`,
      color: `${Color.OnSurface} !important`,
    },
  },
  tablist: {
    borderBottom: '1px solid',
    borderBottomColor: `${Color.Primary500} !important`,
  },
});

// export the component theme
export const tabsTheme = defineMultiStyleConfig({ baseStyle });
